// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatScrollToBottomButton-modulebutton__TQhNl";
var _2 = "GretaAIChatScrollToBottomButton-modulehidden__h9tA7";
export { _1 as "button", _2 as "hidden" }
